<template>
  <div>
    <app-header></app-header>
    <h1 class="display-4 text-center">User Login</h1>
    <div class="container-fluid w-50 mt-5 bg-light">
      <div class="btn-danger text-center mb-3" v-show="error !== null">{{ error }}</div>
      <form @submit.prevent="login">
        <div class="form-group">
          <label class="label">E-mail</label>
          <input
            type="text"
            class="input form-control"
            @input="$v.form.email.$touch()"
            v-model.trim="form.email"
          />
          <div v-if="$v.form.email.$dirty">
            <div class="text-danger" v-if="!$v.form.email.required">Email is required!</div>
            <div class="text-danger" v-if="!$v.form.email.email">Email is not valid!</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Password</label>
          <input
            type="password"
            class="input form-control"
            @input="$v.form.password.$touch()"
            v-model.trim="form.password"
          />
          <div v-if="$v.form.password.dirty">
            <div class="text-danger" v-if="!$v.form.password.required">Password required!</div>
          </div>
        </div>

        <div class="text-center">
          <button class="btn btn-primary mb-3" :disabled="loading" type="submit">
            Login
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="loading" class="sr-only">Loading...</span>
          </button>
        </div>
      </form>
      <div v-if="!loading" class="text-center">
        <router-link to="/register">No login? Register here.</router-link>
      </div>
      <div v-if="!loading" class="text-center">
        <router-link to="/pwreset">Password reset</router-link>
      </div>
      <div v-if="!loading" class="text-center mt-3 pb-3">
        <router-link to="/terms-and-conditions">Terms &amp; Conditions</router-link>
        <span>-</span>
        <router-link to="/privacy-policy">Privacy Policy</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import { required, email } from "vuelidate/lib/validators";
import store from "../../ClientApp/store";

export default {
  components: {
    AppHeader
  },
  data: function() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    login() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      const payload = {
        email: this.form.email,
        password: this.form.password
      };
      this.$store
        .dispatch("login", payload)
        .then(() => {
          this.error = null;
          this.form.email = "";
          this.form.password = "";
          this.$store.dispatch("getTranslations");
          this.$store.dispatch("getHandles");
          this.$store.dispatch("getProfiles");
          this.$store.dispatch("getMotors");
          this.$store.dispatch("getInvisitopProfiles");
          this.$store.dispatch("getVersion");
          this.$router.push("/projects/0");
        })
        .catch(error => {
          this.error = error.data;
        });
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/intro/Login.vue